import { TypographyFontSize } from '@design-system/components/atoms/typography/entities/typography.types';

export enum AlertType {
  Default = 'default',
  Warning = 'warning',
  Error = 'error',
  Confirmed = 'confirmed',
}

export enum AlertSize {
  XS = 'xs',
  SM = 'sm',
  RG = 'rg',
  MD = 'md',
}

export enum AlertAlign {
  Center = 'center',
  Top = 'top',
}

export interface AlertProps {
  IconSize: number;
  MessageSize: TypographyFontSize;
}

export const AlertSizeProps: { [key: string]: AlertProps } = {
  [AlertSize.XS]: {
    IconSize: 12,
    MessageSize: TypographyFontSize.Minor,
  },
  [AlertSize.SM]: {
    IconSize: 16,
    MessageSize: TypographyFontSize.XXXS,
  },
  [AlertSize.RG]: {
    IconSize: 18,
    MessageSize: TypographyFontSize.XXS,
  },
  [AlertSize.MD]: {
    IconSize: 20,
    MessageSize: TypographyFontSize.XS,
  },
};
